import { useState, useEffect } from "react";

import { CandidateRoutesMode } from "api/candidate_routes";
import { useGetCandidateRoutesApi } from "hooks/api";
import { SuggestedPreparedRoute } from "models/suggestedPreparedRoute";

interface FetchCandidateRoutesCondition {
  departureId: number;
  arrivalId: number;
  mode?: CandidateRoutesMode;
}
export const useCandidateRoutes = (): [
  SuggestedPreparedRoute[],
  (routes: SuggestedPreparedRoute[]) => void,
  (condition: FetchCandidateRoutesCondition | null) => void,
  boolean
] => {
  const [fetchCondition, setFetchCondition] =
    useState<FetchCandidateRoutesCondition | null>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [routes, setRoutes] = useState<SuggestedPreparedRoute[]>([]);
  const getApi = useGetCandidateRoutesApi();

  useEffect(() => {
    (async () => {
      if (!fetchCondition) {
        setRoutes([]);
        setIsLoaded(false);
        return;
      }

      setIsLoaded(false);
      setRoutes([]);
      const suggestedPreparedRoutes = await getApi({
        departure_address_id: fetchCondition.departureId,
        arrival_address_id: fetchCondition.arrivalId,
        mode: fetchCondition.mode,
      });
      setIsLoaded(true);
      setRoutes(suggestedPreparedRoutes);
    })();
  }, [getApi, fetchCondition]);

  return [routes, setRoutes, setFetchCondition, isLoaded];
};
